const styles = {
  ModalStyle: {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
      position: "absolute",
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      border: "1px solid #ccc",
      background: "#fff",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "30px",
      outline: "none",
     
      width: "calc(100% - 32px)",
      maxWidth: "400px",
      height: "auto",
      maxHeight: "calc(100vh - 32px)",
      margin: "0"
    }
  }
};

export default styles;
